// Lightweight top-bar "you are here" — shows just the active Project (the Company
// layer is hidden from the UI — R32). Read-only; switching happens in the on-page
// "Working in" bar. The project pill is tinted by a deterministic per-PROJECT color.
import React from "react";
import { useProjects } from "../ProjectContext";
import { companyColor } from "./CompanyAvatar";

export default function ProjectBreadcrumb() {
  const { activeProject } = useProjects();
  const project = activeProject?.displayName || "My Data";
  // Color keyed on the project id (not the company) so identity is per-project.
  const [bg, fg] = companyColor(activeProject?.projectId || "default");
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "7px", minWidth: 0 }}>
      <span style={{
        display: "inline-flex", alignItems: "center", padding: "3px 11px", borderRadius: "999px",
        background: bg, color: fg, fontSize: "12.5px", fontWeight: 800,
        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "220px",
        border: `1px solid ${fg}22`,
      }}>{project}</span>
    </span>
  );
}
